export default __webpack_public_path__ + "static/media/new_message.2b5934b6.svg";